// text contents for Register.tsx
export const register = {
	title: `New Profile Registration`,
	subtitle: `Step 1 of 2`,
};
